import React, { useState, Fragment, useContext, useEffect } from "react";
import Layout from "components/sales/layout/layout";
import localization from "../../../assets/localization/localization";
import CardSection from "components/sales/cardSection/cardSection";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "../../../components/sales/Input/dropDownInput/dropDownInput";
import { Button, Table } from "react-bootstrap";
import Images from "assets/images/imageData";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { toast } from "react-toastify";
import { setLocalLogin } from "services/utils/storages/storages";

const SalesOrderReturn = ({
  fetchSalesReturnMrfDetails,
  fetchSalesReturnMrfShipments,
  getSalesReturnMrfDetails = {},
  getSalesReturnShipments = {},
  sendSalesReturnDataToErp,
  saveSalesReturnOnErp = {},
  match,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [formData, setData] = useState({
    outward_mrf_number: "",
    return_quantity: {},
  });
  const { baseUrl } = useContext(BaseUrl);
  const [invalidQuantities, setInvalidQuantities] = useState(new Set());
  const [shipmentId, setShipmentId] = useState(0);
  const [prefilledDropDown, setPrefilledDropDown] = useState({ id: null, value: '' });

  const handleMrfCheck = async () => {
    const outWardMrfNumber = formData?.outward_mrf_number;
    setIsLoading(true);
    await fetchSalesReturnMrfShipments(outWardMrfNumber);
    setIsLoading(false);
  };

  const handleShipment = async () => {
    setIsLoading(true);
    await fetchSalesReturnMrfDetails(formData?.outward_mrf_number, prefilledDropDown.value);
    setIsLoading(false);
  }

  useEffect(() => {
    if(prefilledDropDown.id){
      (async() => {
        await fetchSalesReturnMrfDetails(formData?.outward_mrf_number, prefilledDropDown.id);
      })()
    }
  }, [prefilledDropDown])

  // useEffect(() => {
  //   (async() => {
  //     await fetchSalesReturnMrfDetails(0);
  //   })()
  // }, [fetchSalesReturnMrfDetails])

  
  const handleQuantityChange = (
    shipment,
    index,
    value,
    matCode,
    price,
    actualQty
  ) => {
    const shipmentNumber = shipment.split(" : ")[1].split(" ")[0];
    const quantity = parseInt(value, 10);

    setData((prev) => {
      const updatedQuantities = { ...prev.return_quantity };

      if (!updatedQuantities[shipmentNumber]) {
        updatedQuantities[shipmentNumber] = [];
      }

      if (quantity > actualQty) {
        setInvalidQuantities(
          (prevSet) => new Set([...prevSet, `${shipmentNumber}-${index}`])
        );
      } else {
        setInvalidQuantities((prevSet) => {
          const newSet = new Set(prevSet);
          newSet.delete(`${shipmentNumber}-${index}`);
          return newSet;
        });
      }

      updatedQuantities[shipmentNumber][index] = {
        Item_No: matCode,
        Quantity: quantity,
        Unit_Price: price,
        From_Location: "HR01",
        Serial_No: "",
        Free_Text_Spec: "",
        Gen_Prod_Posting_Group: "CORPORATE",
      };

      return { ...prev, return_quantity: updatedQuantities };
    });
  };

  const handleModalHide = () => setIsModal(false);

  const handleSubmit = async () => {
    if (invalidQuantities.size > 0) {
      toast.error(
        "Return quantity cannot be greater than the actual quantity!"
      );
      return;
    }
    const payload = {
      outward_mrf_number: formData?.outward_mrf_number,
      material_type_id: 30,
      item_data: formData?.return_quantity,
    };
    setIsLoading(true);
    const res = await sendSalesReturnDataToErp(payload);
    if (res) {
      setIsModal(true);
    }
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        {getSalesReturnMrfDetails !== null &&
          getSalesReturnMrfDetails !== undefined &&
          Object.keys(getSalesReturnMrfDetails).length > 0 && (
            <Button onClick={handleSubmit} className="btn btn-primary">
              {localization.submitDtl}
              <img src={Images?.ArrowRight} alt="" />
            </Button>
          )}
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.salesOrderReturnMrf}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      {/* Input Section */}
      <CardSection title={localization.salesOrderReturnMrf} panelN={null}>
        <div className="row mb-3">
          <div className="col-md-10">
            <ConstantInput
              label={localization.outwardMrfNumber}
              required
              handleChange={(value) =>
                setData({ ...formData, outward_mrf_number: value })
              }
              errorMsg={localization.requiredErrorMg}
              isStarRequired={true}
            />
          </div>
          <div className="col-md-2">
            <Button className="btn btn-sm btn-primary" onClick={handleMrfCheck}>
              Check
            </Button>
          </div>
        </div>
        <div className="row">
          {
            getSalesReturnShipments !== null &&
            getSalesReturnShipments !== undefined &&
            getSalesReturnShipments.length > 0 && 
            <div className="col-6">
                <DropDownInput
                    data={getSalesReturnShipments}
                    label={localization.shipmentListing}
                    getIdValue={(val) => {
                      setPrefilledDropDown({id: val.id, value: val.val});
                    }}
                    value={setPrefilledDropDown.value}
                />
            </div>
          }
          
          {getSalesReturnMrfDetails !== null &&
            getSalesReturnMrfDetails !== undefined &&
            Object.keys(getSalesReturnMrfDetails).length > 0 &&
            Object.entries(getSalesReturnMrfDetails).map(
              ([shipment, items]) => (
                <Fragment key={shipment}>
                  <div className="col-md-12 mb-3">
                    <h5>{shipment.split("_")[0]}</h5>
                  </div>
                  <Table bordered striped responsive>
                    <thead className="bg-light">
                      <tr>
                        <th>Item Name</th>
                        <th>Qty</th>
                        <th>Unit Price</th>
                        <th>Qty To Return</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={index}>
                          <td>{item["Item Name"]}</td>
                          <td>{item.Qty}</td>
                          <td>{item["Unit Price"]}</td>
                          <td>
                            <ConstantInput
                              type={"number"}
                              label={localization.returnQuantity}
                              required
                              handleChange={(value) =>
                                handleQuantityChange(
                                  shipment,
                                  index,
                                  value,
                                  item["Item Code"],
                                  item["Unit Price"],
                                  item.Qty
                                )
                              }
                              errorMsg={localization.requiredErrorMg}
                              isStarRequired={true}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Fragment>
              )
            )}
        </div>
      </CardSection>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.salesReturnSendToErp}</h5>
          <Link
            to={`${baseUrl}/mrf-listing/2`}
            className="btn btn-primary mb-4"
          >
            {"Back to list"} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default SalesOrderReturn;
